import { render } from "./ConfiguracaoInicialFinanceiro.vue?vue&type=template&id=575486bb&scoped=true&ts=true"
import script from "./ConfiguracaoInicialFinanceiro.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialFinanceiro.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialFinanceiro.vue?vue&type=style&index=0&id=575486bb&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575486bb"]])

export default __exports__